import { render } from 'solid-js/web';
import App from './app/app';

let dispose;

/**
 * renderApp
 * @param {void}
 * @returns {void}
 */
const renderApp = () => {
  dispose && dispose();
  dispose = render(() => <App />, document.getElementById('root'));
};

/** HMR */
module['hot'] &&
  module['hot'].accept('./app/app', () => {
    renderApp();
  });

renderApp();
